import { PrintQueueStatusSchema } from "@redotech/redo-fulfillment-printing-common/print-queue-status";
import * as z from "zod";

export const cancelPrintJobs = {
  name: "cancelPrintJobs" as const,
  input: z.object({ printJobs: z.array(z.string()) }),
  output: PrintQueueStatusSchema,
};

export type CancelPrintJobsInput = z.infer<typeof cancelPrintJobs.input>;
